export type UseOpenTractiveReferralResult = {
  openTractiveReferral: () => void;
};

export type UseOpenTractiveReferralProps = {
  tractiveCode: string;
};

export const getUrlWithCode = (code: string): string => {
  return `https://rover.tractive.com/?utm_source=rover-tractive&utm_medium=popup&utm_campaign=rover-x-tractive&code=${code}`;
};
